import React from 'react';

const LogoIcon = ({ className = "w-12 h-12", bgVariant = "transparent" }) => {
  // New logo URL provided
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvcG5n/7c87760c4694922b4e90a2397eebc6df.png";
  
  return (
    <div className={`${className} aspect-square rounded-full overflow-hidden flex items-center justify-center shrink-0 ${bgVariant === 'olive' ? 'bg-brand-olive' : ''}`}>
      <img 
        src={logoUrl} 
        alt="R. Venue Logo" 
        // scale-[1.45] zooms in precisely enough to crop out the white square
        // padding in the original image, making the green circle fill the frame
        className="w-full h-full object-cover transform scale-[1.45]"
      />
    </div>
  );
};

export default LogoIcon;